import React, { useState, useEffect } from "react";
import { Redirect } from 'react-router-dom'
import axios from 'axios'

import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col
} from "reactstrap";
import useForm from '../../lib/useForm'
import settings from '../../settings'
import rotas from '../../services/rotas'
import SweetAlert from 'sweetalert-react'
import 'sweetalert/dist/sweetalert.css'
import './style.css'

// import NumberFormat from 'react-number-format';

const INITIAL_FORM = {
  cpf: '',
  senha: ''
}

const Login = () => {
  const [form, onChange] = useForm(INITIAL_FORM)
  const [autenticado, setAutenticado] = useState(false)
  const [erro, setErro] = useState('')
  useEffect(() => {
    document.body.classList.toggle("login-page");
    return () => {
      document.body.classList.toggle("login-page");
    }
  }, [])
  useEffect(() => {
    const token = sessionStorage.getItem('token')
    if (token) {
      setAutenticado(true)
    }
  }, [])

  const logar = async (credenciais) => { // eslint-disable-line no-unused-vars
    const url = settings.url + rotas.login
    try {
      const token = await axios.post(url, credenciais)
      // console.log(token);
      if (token.data.erro === "nao") {
        sessionStorage.setItem('token', token.data.token)
        sessionStorage.setItem('rede', token.data.rede)
        sessionStorage.setItem('usuario', token.data.usuario)
        setAutenticado(true)
        // console.log(token.data.token)
      } else {
        setErro('Erro ao identificar usuário')
      }
    } catch (err) {
      setErro('Erro ao identificar usuário')
    }
  }
  if (autenticado) {
    return <Redirect to='/painelwebgestor/admin/Principal' />
  }

  return (
    <div className="lock-page">
      <Container>
        <Col className="ml-auto mr-auto" lg="4" md="6">
          <Card className="card-lock text-center">
            <CardHeader>
              <img
                alt="..."
                src={require("assets/img/faces/user_1.jpg")}
              />
            </CardHeader>
            <CardBody>
              <CardTitle className="mt-0" tag="h4">Nome Usuário</CardTitle>
              <InputGroup className="mb-0">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="nc-icon nc-key-25" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Senha"
                  type="password"
                  autoComplete="off"
                  value={form.senha}
                  onChange={onChange('senha')}
                />
              </InputGroup>
            </CardBody>
            <CardFooter>
              <Button
                className="btn-round"
                color="primary"
                href=""
                onClick={e => e.preventDefault()}
                outline
              >
                Desbloquear
              </Button>

              <SweetAlert
                show={erro !== ''}
                danger
                style={{ display: "block", marginTop: "-100px" }}
                title="Atenção!"
                text={erro}
                onConfirm={() => setErro('')}
                confirmBtnBsStyle="info"
              />
            </CardFooter>
          </Card>
        </Col>
      </Container>
      <div
        className="full-page-background"
        style={{
          backgroundImage: `url(${require("assets/img/bg/webgestor_login_bg.jpg")})`
        }}
      />
    </div>
  );
}

export default Login;
